import React, { Component } from "react";
import { isAuthenticated, getUSER } from "../services/auth";
import { isAuthenticatedNode, getUserNode } from "../services/auth_node";
import habilita_mentoria from "../utils/home_functions/habilita_mentoria";

import { verify_mobile } from "../utils/Utils";
import {
  Button,
  Dimmer,
  Image,
  Header,
  Modal,
  Icon,
  Popup,
} from "semantic-ui-react";
import limpar_titulo from "../utils/home_functions/limpar_titulo";
import ReactHtmlParser from "react-html-parser";
import { producaov2 as api } from "../services/apis";
import apivoitto from "../services/apivoitto";

import { inscricaoRealizada } from "../main/cursos/cursosAction";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

class ItemWithDimmerNode extends Component {
  constructor(props) {
    super(props);

    this.state = {
      active: this.props.active != undefined ? this.props.active : false,
      modalOpen: false,
      cursos_combo: [],
      apertou_ao_vivo: false,
      hasDigital: false,
    };
  }

  componentWillMount() {
    if (this.props.isWorkshop) {
      api
        .get(`workshop/verify_digital/${this.props.main.id}`)
        .then((res) => {
          this.setState({
            hasDigital: true,
            url_amigavel: res.data.url,
            id_workshop: res.data.id_workshop,
          });
        })
        .catch(() => {
          this.setState({ hasDigital: false });
        });
    }
  }

  componentDidUpdate() {
    if (
      this.state.active != this.props.active &&
      this.props.active != undefined
    ) {
      this.setState({
        active: this.props.active,
      });
    }
  }

  onClickWorkshop() {
    if (this.state.hasDigital) {
      if (
        this.props.cursosAluno &&
        this.props.cursosAluno.indexOf(`${this.state.id_workshop}`) > -1
      ) {
        window.open(`/online/live/${this.state.id_workshop}`, "_blank");
      } else if (getUserNode().premium) {
        habilita_mentoria(atob(this.state.id_workshop), false, false, true);
      } else {
        window.open(`/digital/${this.state.url_amigavel}`, "_blank");
      }
    } else {
      if (
        (this.props.cursosAluno &&
          this.props.cursosAluno.indexOf(`${this.props.main.id}`) > -1) ||
        getUserNode().premium
      ) {
        window.open(`/online/live/${this.props.main.id}`, "_blank");
      } else if (getUserNode().premium) {
        habilita_mentoria(atob(this.props.main.id), false, false, true);
      } else {
        window.open(`/premium`, "_blank");
      }
    }
  }

  returnButtonTextWorkshop() {
    const array = this.props.cursosAluno
      ? this.props.cursosAluno.toString().split(",")
      : [];
    console.log(array.indexOf(`${this.props.main.id}`));
    if (this.state.hasDigital) {
      if (
        (this.props.cursosAluno &&
          this.props.cursosAluno.indexOf(`${this.props.main.id}`) > -1) ||
        getUserNode().premium
      ) {
        return "Assistir";
      } else {
        return "Saiba Mais";
      }
    } else {
      if (
        (this.props.cursosAluno &&
          this.props.cursosAluno.indexOf(`${this.props.main.id}`) > -1) ||
        getUserNode().premium
      ) {
        return "Assistir";
      } else {
        return "Seja Premium!";
      }
    }
  }

  handleOpen = () => this.setState({ modalOpen: true });
  handleClose = () => this.setState({ modalOpen: false });
  handleShow = () => this.setState({ active: true });
  handleHide = () => this.setState({ active: false });
  brokenImg(ev) {
    ev.target.src = ev.target.src.replace(".jpg", ".png");
  }

  data_para_extenso = ({ data, ao_vivo = false }) => {
    if (data.data === undefined) return;
    if (ao_vivo) {
      data = new Date(data.data);
    }
    var dia_semana = [
      "Domingo",
      "Segunda-feira",
      "Terça-feira",
      "Quarta-feira",
      "Quinta-feira",
      "Sexta-feira",
      "Sábado",
    ][data.getDay()];
    var dia = data.getDate();
    var mes = [
      "Janeiro",
      "Fevereiro",
      "Março",
      "Abril",
      "Maio",
      "Junho",
      "Julho",
      "Agosto",
      "Setembro",
      "Outubro",
      "Novembro",
      "Dezembro",
    ][data.getMonth()];
    var ano = data.getFullYear();
    return `${dia_semana}, ${dia} de ${mes} de ${ano}`;
  };

  redirect_me(link, main) {
    api
      .get(`/live/${main.id}`)
      .then(() => {
        window.open(`/online/live/${main.id}`, "_blank");
      })
      .catch(() => {
        const redirect = this.props.link ? this.props.link : link;
        this.props.target !== undefined
          ? window.open(link, "_blank")
          : localStorage.setItem("redirect", redirect);
        window.location.href = redirect;
      });
    console.log("");
  }

  redirectItem(link, main) {
    api
      .get(`/live/${main.id}`)
      .then(() => {
        window.open(`/online/live/${main.id}`, "_blank");
      })
      .catch((err) => {
        console.error(err);
        console.log("Erro no redirecionamento");
        this.props.target !== undefined
          ? window.open(link, "_blank")
          : (window.location.href = link);
      });
  }

  render_cursos_combo() {
    return (
      <div
        className="ui grid"
        style={{ width: "100%", textAlign: "center", justifyContent: "center" }}
      >
        {this.state.cursos_combo.map((v) => {
          return (
            <div
              data-inverted
              data-tooltip={
                this.props.button_txt ? this.props.button_txt : `Assistir`
              }
              style={{
                width: "30%",
                height: "26vh",
                marginLeft: "1%",
                padding: "3px",
                margin: "5px",
                cursor: "pointer",
              }}
            >
              <img
                onClick={() => {
                  window.location.href = `/online/assistir/${v.id}`;
                }}
                style={{ width: "100%", height: "100%" }}
                src={`https://files.voitto.com.br/cursos/bigger/${v.url_amigavel}.jpg`}
                onError={(e) => this.brokenImg(e)}
              />
            </div>
          );
        })}
      </div>
    );
  }

  data_horario(main) {
    if (main.data) {
      const { hora_inicial, hora_final } = main.data;
      return `Das ${hora_inicial || "00:00"} às ${hora_final || "00:00"}.`;
    }
  }

  toggleMentoria = async (main) => {
    try {
      const response = await api.post(`/inscricao/${main.id}`);
      if (response.data) {
        this.props.inscricaoRealizada();
        this.setState({
          apertou_ao_vivo: true,
          active: true,
        });
        this.VerTodosEventos();
      }
      return;
    } catch (err) {
      return;
    }
  };

  abreviaNome = (nome) => {
    if (nome) {
      const nomeLimpo = limpar_titulo(nome);
      const nameTruncado =
        nomeLimpo.length > 50 ? nomeLimpo.substring(0, 50) + "..." : nomeLimpo;
      return nameTruncado;
    }
    return nome;
  };

  abrirLogin() {
    localStorage.setItem("redirect", "/ao-vivo");
    window.location.href = `/login?redirect=/ao-vivo`;
  }

  VerTodosEventos() {
    if (
      document.getElementById("controleTab") != null ||
      document.getElementById("home-control-mentoria") != null
    ) {
      window.location.href.indexOf("aulas-aovivo") > -1 &&
        window.location.reload();
    }
  }

  render_dimmer(main) {
    const { active } = this.state;
    //setters
    const titulo = (() => {
      if (main.treinamento) {
        if (main.treinamento.slogan) {
          return main.treinamento.slogan;
        }
        if (main.curso != undefined && main.curso != "") {
          return main.curso.titulo;
        }
        if (main.slogan != undefined && main.slogan != "") {
          return main.slogan;
        }
        if (main.titulo != undefined && main.titulo != "") {
          return main.titulo;
        }
      }
      return this.props.titulo;
    })();
    let link = (() => {
      if (
        this.props.linkSimulado !== null &&
        this.props.linkSimulado !== undefined
      ) {
        return this.props.linkSimulado;
      }
      if (this.props.link != undefined) {
        return this.props.link;
      }
      return `/online/assistir/${main.id}`;
    })();

    let button_txt = "";
    if (this.props.button_txt != undefined) {
      button_txt = this.props.button_txt;
    } else if (
      (this.props.h_i !== null || this.props.h_i === null) &&
      this.props.h_f === null &&
      this.props.linkSimulado !== null
    ) {
      button_txt = "Ir para o simulado";
    } else if (
      this.props.h_i !== undefined &&
      this.props.h_f !== undefined &&
      this.props.linkSimulado !== null
    ) {
      button_txt = "Ver nota";
    } else {
      button_txt = "Assistir";
    }
    let imagem = "";
    if (this.props.imagem != undefined) {
      imagem = this.props.imagem + "?size=350";
    } else {
      imagem = `https://files.voitto.com.br/cursos/bigger/${main.url_amigavel}.jpg`;
    }

    if (this.props.verificarImagensAoVivo != undefined) {
      if (main.curso != undefined && main.curso.indexOf("LETS") > -1) {
        imagem = `https://files.voitto.com.br/cursos/bigger/${main.url_amigavel}.jpg`;
      } else {
        imagem = `https://files.voitto.com.br/cursos/bigger/${main.url_amigavel}.jpg`;
      }
    }
    if (!isAuthenticated() || !this.props.premium) {
      if (this.props.restricao_premium && !this.props.premium) {
        button_txt = "Seja Premium!";
        link = `/premium/`;
      } else if (this.props.restricao_premium_after) {
        console.log("Premium");

        if (main.data) {
          let dataPlus = main.data + " 23:59:00";
          if (new Date(dataPlus) >= new Date()) {
            button_txt = "Seja Premium!";
            link = `/premium/`;
          }
        }
      }
    }
    const content = (
      <div class="ui center aligned container">
        <p
          class="ui inverted"
          style={verify_mobile() ? { marginTop: "-10%" } : null}
        >
          {this.abreviaNome(titulo)}
        </p>
        {!this.props.isPassDate && (
          <>
            <p className="subModItem miniB">
              {main.data != undefined &&
              main.data != "ONLINE" &&
              main.data != "" &&
              main.data !== null &&
              this.props.ja_realizadas == false
                ? this.data_para_extenso(
                    this.props.ao_vivo
                      ? { data: main.data, ao_vivo: true }
                      : { data: main.dataReal, ao_vivo: false }
                  )
                : ""}
            </p>
            {this.props.isMentoria && !this.props.isPassHour && (
              <p className="subModItem miniB">{this.data_horario(main)}</p>
            )}
          </>
        )}

        {this.props.isMentoria && !this.props.isWorkshop ? (
          (this.props.isSubscribed && this.props.proximaMentoria == true) ||
          (this.state.apertou_ao_vivo == true &&
            this.props.proximaMentoria == true) ? null : (
            <Button
              class="ui inverted"
              onClick={() => {
                button_txt.indexOf("Garantir Minha Vaga") > -1 == true
                  ? this.toggleMentoria(main)
                  : button_txt.indexOf("Seja Premium!") > -1 == true
                  ? this.redirectItem(link, main)
                  : this.redirect_me(link, main);
              }}
              className="aovivo_inscr"
              inverted
            >
              {button_txt}
            </Button>
          )
        ) : (
          !this.props.isWorkshop && (
            <Button
              class="ui inverted"
              onClick={
                button_txt.indexOf("Ver cursos") > -1 == true
                  ? () => {}
                  : () => {
                      this.redirect_me(link, main);
                    }
              }
              className="aovivo_inscr"
              inverted
            >
              {button_txt}
            </Button>
          )
        )}
        {this.props.isWorkshop && (
          <Button
            class="ui inverted"
            onClick={() => this.onClickWorkshop()}
            className="aovivo_inscr"
            inverted
          >
            {this.returnButtonTextWorkshop()}
          </Button>
        )}
        {this.props.isMentoria &&
          ((this.props.isSubscribed && this.props.proximaMentoria == true) ||
            (this.state.apertou_ao_vivo == true &&
              this.props.proximaMentoria == true)) && (
            <p style={{ marginBottom: 10 }} className="subModItem miniB">
              <a
                onClick={() => this.VerTodosEventos()}
                style={{ cursor: "pointer" }}
              >
                Ver todos os meus eventos agendados
              </a>
            </p>
          )}
      </div>
    );
    return (this.props.isSubscribed && this.props.proximaMentoria == true) ||
      (this.state.apertou_ao_vivo == true &&
        this.props.proximaMentoria == true) ? (
      <Popup
        header={"Sua Vaga está garantida !"}
        content={ReactHtmlParser(
          "&nbspBasta acessar www.voitto.com.br/lives na hora marcada!<br>&nbspAlgumas dicas para aproveitar ao máximo:<br>&nbsp- Reserve um tempo e um local para aumentar seu foco. <br>&nbsp- Envie suas dúvidas e participe!<br>&nbsp- Compartilhe o que aprendeu!(e não se esqueça de marcar @grupovoitto #tonavoitto :))<br>Nos vemos lá..."
        )}
        position="top center"
        open={this.state.active}
        //on='hover'
        trigger={
          <div className={this.props.superHeihgt ? "cont_dimmer" : ""}>
            <Dimmer.Dimmable
              ref={this.dimmer}
              as={Image}
              dimmed={this.state.active}
              dimmer={{ active, content }}
              onMouseOver={() => {
                if (this.props.onMouseOver != undefined) {
                  this.props.onMouseOver();
                } else {
                  this.handleShow();
                }
              }}
              onMouseLeave={() => {
                if (this.props.onMouseLeave != undefined) {
                  this.props.onMouseLeave();
                } else {
                  this.handleHide();
                }
              }}
              src={imagem}
              onError={(e) => this.brokenImg(e)}
            />

            <Modal
              image
              className="modalCombosWithCursos"
              open={this.state.modalOpen}
              onClose={this.handleClose}
              closeIcon
            >
              <Header content="Assista um curso do seu combo:" />
              <Modal.Content>{this.render_cursos_combo()}</Modal.Content>
              <Modal.Actions>
                <Button color="green" onClick={this.handleClose}>
                  <Icon name="checkmark" /> Ok!
                </Button>
              </Modal.Actions>
            </Modal>
          </div>
        }
      />
    ) : (
      <div className={this.props.superHeihgt ? "cont_dimmer" : ""}>
        <Dimmer.Dimmable
          as={Image}
          dimmed={active}
          dimmer={{ active, content }}
          onMouseOver={() => {
            if (this.props.onMouseOver != undefined) {
              this.props.onMouseOver();
            } else {
              this.handleShow();
            }
          }}
          onMouseLeave={() => {
            if (this.props.onMouseLeave != undefined) {
              this.props.onMouseLeave();
            } else {
              this.handleHide();
            }
          }}
          src={imagem}
          onError={(e) => this.brokenImg(e)}
        />

        <Modal
          image
          className="modalCombosWithCursos"
          open={this.state.modalOpen}
          onClose={this.handleClose}
          closeIcon
        >
          <Header content="Assista um curso do seu combo:" />
          <Modal.Content>{this.render_cursos_combo()}</Modal.Content>
          <Modal.Actions>
            <Button color="green" onClick={this.handleClose}>
              <Icon name="checkmark" /> Ok!
            </Button>
          </Modal.Actions>
        </Modal>
      </div>
    );
  }
  render() {
    return this.render_dimmer(this.props.main);
  }
}

const mapStateToProps = (store) => {
  return {};
};

const mapDispathToProps = (dispatch) =>
  bindActionCreators({ inscricaoRealizada }, dispatch);
export default connect(mapStateToProps, mapDispathToProps)(ItemWithDimmerNode);
